export const AccountStatus = {
  ACTIVE: 'Active',
  PENDING: 'Pending',
  INACTIVE: 'Inactive',
};

export const statusList = [
  { id: AccountStatus.ACTIVE, name: AccountStatus.ACTIVE },
  { id: AccountStatus.INACTIVE, name: AccountStatus.INACTIVE },
  { id: AccountStatus.PENDING, name: AccountStatus.PENDING },
];
